/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('ModalConversationCtrl', function($scope, $uibModalInstance, conversation, identity) {
    $scope.me           = identity;
    $scope.conversation = conversation;
    $scope.newMessage   =
        {content: ''};

    $scope.ok = () => $uibModalInstance.close($scope.newMessage);

    return $scope.cancel = () => $uibModalInstance.dismiss('cancel');
});
